<template>
  <Component
      v-if="icon"
      :is="iconComponent"
      :key="mappedIconName"
      :icon="mappedIconName"
  />
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue';

const IconSolid = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-solid" */ '@/components/FaIcon/IconSolid.vue'));
const IconRegular = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-regular" */ '@/components/FaIcon/IconRegular.vue'));
const IconLight = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-light" */ '@/components/FaIcon/IconLight.vue'));
const IconThin = defineAsyncComponent(() => import(/* webpackChunkName: "chunks/fontawesome-thin" */ '@/components/FaIcon/IconThin.vue'));

const props = defineProps({
  icon: {
    type: String,
    required: false,
  },
});

const mappedIconName = computed(() => `${props.icon || ''}`.trim()
  .replace('far ', 'fa-regular ')
  .replace('fas ', 'fa-solid ')
  .replace('fat ', 'fa-thin ')
  .replace('fal ', 'fa-light '));

const iconComponent = computed(() => {
  if (mappedIconName.value.startsWith('fa-regular')) {
    return IconRegular;
  }
  if (mappedIconName.value.startsWith('fa-solid')) {
    return IconSolid;
  }
  if (mappedIconName.value.startsWith('fa-thin')) {
    return IconThin;
  }
  return IconLight;
});
</script>
